import React from 'react'
import {
  ILayout_Render,
  ILayout_Cell_Props_Empty,
} from '../types/layout'

const SpacerComponent: ILayout_Render<ILayout_Cell_Props_Empty> = ({
  cell,
}) => {
  return (
    <div>
      
    </div>
  )
}

export default SpacerComponent